require('angular-material');
require('./dist/md-time-picker');

module.exports = 'md.time.picker';



//////////////////
// WEBPACK FOOTER
// ./~/angular-material-time-picker/index.js
// module id = 233
// module chunks = 0